import { render, staticRenderFns } from "./AdmissionCircular.vue?vue&type=template&id=2fbab6b2&scoped=true&"
import script from "./AdmissionCircular.vue?vue&type=script&lang=js&"
export * from "./AdmissionCircular.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionCircular.vue?vue&type=style&index=0&id=2fbab6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbab6b2",
  null
  
)

export default component.exports